import axios from 'axios';
import errorHandler from './errorHandler.js';

export default function (errorCallback) {
  const handleError = errorHandler(errorCallback);
  const authUrl = process.env.VUE_APP_OAUTH || 'http://localhost:8881';
  const accountUrl = process.env.VUE_APP_ACCOUNT_CENTRAL || 'http://localhost:8881';
  const conf = (token) => {
    return {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json'
      }
    };
  };

  return {
    getUserInformation: async (token) => {
      try {
        const response = await axios.get(`${accountUrl}/me`, conf(token));
        return response.data;
      } catch (error) {
        throw handleError(error);
      }
    },
    keepAlive: async (token) => {
      try {
        return await axios.post(`${authUrl}/o/inactivity/reset`, undefined, conf(token));
      } catch (error) {
        throw handleError(error);
      }
    }
  };
}
